import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { Rectangle } from "pixi.js";
import { RescueLogic } from "../../../Logic/MiniGames/RescueLogic";
import { RescueModel } from "../../../Models/MiniGames/RescueModel";

export interface IRescueButtonControllerOptions {
    mouseDown: () => void;
    mouseUp: () => void;
}

export class RescueButtonController extends AnimationBaseController {
    public $model: RescueModel;
    constructor(
        @Inject private options: IRescueButtonControllerOptions,
        @Inject private logic: RescueLogic,
    ) {
        super("RescueButtonController");
    }

    public getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: () => { this.options.mouseDown(); this.gotoAndStop("down"); },
            onPointerUp: () => { this.options.mouseUp(); this.gotoAndStop("up"); },
            onPointerOut: () => { this.options.mouseUp(); this.gotoAndStop("up"); },
            onPointerOver: ()=>{ this.gotoAndStop("over");}
        }
    }

    public onInitialize() {
        this.gotoAndStop("over");
        this.container.hitArea = new Rectangle(-this.width/2, -this.height/2, this.width, this.height);
        this.gotoAndStop("up");
    }
}